import './assets/fonts/roboto/index.css';
import './assets/fonts/roboto-mono/index.css';
import './assets/fonts/flama-light/index.css';
import './assets/fonts/benton-sans-pro/index.css';
import './assets/fonts/crimson-text/index.css';

import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import { isAfter, isSameDay, parseISO } from 'date-fns';
import process from 'process';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import { appStore } from '!core/redux/app.store';
import { themeBFACM } from '!styles/themeBFACM';
import { getDateTimeFromTimeZone } from '»utils/time';

import { App, AppOffline } from './app';
import { ErrorBoundary } from './ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import {
  baseTheme,
  themeAurea,
  themeBancoValor,
  themeBPC,
  themeHemera,
  themeStandard,
} from './styles';

window.process = process;

// eslint-disable-next-line no-undef
const myConfig = config();

let localTheme;

switch (myConfig.client?.toUpperCase()) {
  case 'AUREA':
    localTheme = themeAurea();
    break;
  case 'STINVEST':
    localTheme = themeStandard();
    break;
  case 'BFACM':
    localTheme = themeBFACM();
    break;
  case 'HEMERA':
    localTheme = themeHemera();
    break;
  case 'BPC':
    localTheme = themeBPC();
    break;
  case 'BVALOR':
    localTheme = themeBancoValor();
    break;

  default:
    localTheme = baseTheme();
    break;
}

const checkIfSameOrAfterMaintenanceDate = () => {
  const currentTimePT = getDateTimeFromTimeZone({
    timeZone: 'Europe/Lisbon',
  });
  const maintenanceTime = parseISO(myConfig.underMaintenanceDateTimePT);

  return (
    (isSameDay(currentTimePT, maintenanceTime) &&
      isAfter(currentTimePT, maintenanceTime)) ||
    isAfter(currentTimePT, maintenanceTime)
  );
};

const page = ReactDOM.createRoot(document.getElementById('page'));

if (checkIfSameOrAfterMaintenanceDate()) {
  page.render(
    <React.StrictMode>
      <ThemeProvider theme={localTheme}>
        <CssBaseline />

        <AppOffline />
      </ThemeProvider>
    </React.StrictMode>,
  );
} else {
  page.render(
    <React.StrictMode>
      <Provider store={appStore}>
        <ThemeProvider theme={localTheme}>
          <CssBaseline />

          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </ThemeProvider>
      </Provider>
    </React.StrictMode>,
  );
}

let hasReloadedForServiceWorkerUpdate = false;

serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    const waitingServiceWorker = registration.waiting;

    if (waitingServiceWorker) {
      waitingServiceWorker.addEventListener('statechange', (event) => {
        const serviceWorker = event?.target;

        if (
          serviceWorker &&
          serviceWorker.state === 'activated' &&
          hasReloadedForServiceWorkerUpdate === false
        ) {
          hasReloadedForServiceWorkerUpdate = true;
          window.location.reload();
        }
      });

      waitingServiceWorker.postMessage({ type: 'SKIP_WAITING' });

      if (
        waitingServiceWorker.state === 'activated' &&
        hasReloadedForServiceWorkerUpdate === false
      ) {
        hasReloadedForServiceWorkerUpdate = true;
        window.location.reload();
      }
    }
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
